import React from 'react';

const TotalSection = ({ items }) => {
  const subtotal = items.reduce((sum, item) => sum + item.subtotal, 0);
  const totalDeposits = items.reduce((sum, item) => sum + item.totalDeposit, 0);
  const total = subtotal + totalDeposits;

  return (
    <div className="bg-white rounded-lg p-4 space-y-2">
      <div className="flex justify-between text-gray-500">
        <span>Subtotal</span>
        <span>${subtotal.toLocaleString()}</span>
      </div>
      {totalDeposits > 0 && (
        <div className="flex justify-between text-gray-500">
          <span>Total señas</span>
          <span>${totalDeposits.toLocaleString()}</span>
        </div>
      )}
      <div className="flex justify-between font-bold text-lg pt-2 border-t">
        <span>Total</span>
        <span>${total.toLocaleString()}</span>
      </div>
    </div>
  );
};

export default TotalSection; 